class CustomFeaturedCollectionComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var arrowPath = 'M37.0607 13.0607C37.6464 12.4749 37.6464 11.5251 37.0607 10.9393L27.5147 1.39339C26.9289 0.807608 25.9792 0.807608 25.3934 1.3934C24.8076 1.97918 24.8076 2.92893 25.3934 3.51472L33.8787 12L25.3934 20.4853C24.8076 21.0711 24.8076 22.0208 25.3934 22.6066C25.9792 23.1924 26.9289 23.1924 27.5147 22.6066L37.0607 13.0607ZM9.26192e-08 13.5L36 13.5L36 10.5L-9.26192e-08 10.5L9.26192e-08 13.5Z';

    var bannerSplide = new Splide(this.querySelector('.banner-carousel'), {
      type: 'loop',
      pagination : false,
      gap : 35,
      padding: 300,
      fixedWidth : 365,
      arrowPath: arrowPath,
      breakpoints : {
        1200: {
          perPage: 1,
          perMove: 1,
          fixedWidth : 300,
          gap: 20,
          padding: 180
        },
        989: {
          perPage: 1,
          perMove: 1,
          fixedWidth : 300,
          focus: "center",
          gap: 12,
          padding: 180
        },
        749: {
          perPage: 1,
          perMove: 1,
          fixedWidth : false,
          gap: 8,
          padding: 90
        },
      }
    });
    var arrowPath = 'M36.3536 4.35355C36.5488 4.15829 36.5488 3.8417 36.3536 3.64644L33.1716 0.464462C32.9763 0.2692 32.6597 0.2692 32.4645 0.464462C32.2692 0.659724 32.2692 0.976307 32.4645 1.17157L35.2929 4L32.4645 6.82842C32.2692 7.02369 32.2692 7.34027 32.4645 7.53553C32.6597 7.73079 32.9763 7.73079 33.1716 7.53553L36.3536 4.35355ZM3.08731e-08 4.5L36 4.5L36 3.5L-3.08731e-08 3.5L3.08731e-08 4.5Z';
    var titleSplide = new Splide(this.querySelector('.title-carousel'), {
      type: 'loop',
      perPage : 1,
      perMove: 1,
      isNavigation: true,
      pagination : false,
      arrowPath: arrowPath,
    });

    bannerSplide.sync( titleSplide );
    bannerSplide.mount();
    titleSplide.mount();
  }
}

customElements.define('featured-collection-list', CustomFeaturedCollectionComponent);